import api from "./api";
import type { SearchResponse, SearchParams } from "@/types/search";

const RECENT_SEARCHES_KEY = "recent_searches";
const MAX_RECENT_SEARCHES = 10;

export const searchService = {
  // 통합 검색
  async search(params: SearchParams): Promise<SearchResponse> {
    const response = await api.get<SearchResponse>("/search", { params });
    return response.data;
  },

  // 빠른 검색 (자동완성용)
  async quickSearch(query: string): Promise<SearchResponse> {
    const response = await api.get<SearchResponse>("/search/quick", {
      params: { q: query, page_size: 5 },
    });
    return response.data;
  },

  // 최근 검색어 저장
  saveRecentSearch(query: string): void {
    const trimmedQuery = query.trim();
    if (!trimmedQuery) return;

    const recent = this.getRecentSearches();
    const filtered = recent.filter((item) => item.query !== trimmedQuery);
    const updated = [
      { query: trimmedQuery, timestamp: Date.now() },
      ...filtered,
    ].slice(0, MAX_RECENT_SEARCHES);

    localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(updated));
  },

  // 최근 검색어 조회
  getRecentSearches(): Array<{ query: string; timestamp: number }> {
    try {
      const stored = localStorage.getItem(RECENT_SEARCHES_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  },

  // 최근 검색어 삭제
  removeRecentSearch(query: string): void {
    const recent = this.getRecentSearches();
    const filtered = recent.filter((item) => item.query !== query);
    localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(filtered));
  },

  // 모든 최근 검색어 삭제
  clearRecentSearches(): void {
    localStorage.removeItem(RECENT_SEARCHES_KEY);
  },
};

export default searchService;
